var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ls),function(item,index){return _c('div',{key:index,ref:'chartRef' + index,refInFor:true})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }